export enum DestinationTypeEnum {
  WORDPRESS = 1,
}

export enum DestinationStatusEnum {
  DRAFT = "draft",
  PUBLISHED = "published",
  PENDING = "pending",
}
